module.exports = __webpack_public_path__ + "img/tj.22f076f7.svg";